import * as BulletinActions from './bulletin';
import * as VehSystemsActions from './vehSystems';
import * as VehicleQuery from './vehicleQuery';
import * as QueryActions from './query';

const Actions = {
  ...BulletinActions,
  ...VehSystemsActions,
  ...QueryActions,
  ...VehicleQuery,
};

export default Actions;
